<template>
  <section class="tech__layout">
    <Topbar />
    <div class="tech_layout_row">
      <div class="tech__layout__left">
        <Menubar :style="leftStyle" :isLeft="true">
          <div slot="menu-title" class="menu-box-title">
            <span v-text="menu_title"></span>
          </div>
          <div slot="menu-list" class="menu-box-list">
            <el-menu :default-active="active" background-color="#001529" text-color="#ffffff" active-text-color="#ffd04b" style="max-height:500px" router unique-opened>
              <el-submenu index="1">
                <template slot="title">
                  <!-- <i class="icon icon-ios"></i> -->
                  <span>技术交易规模排名</span>
                </template>

                <el-menu-item index="/tech0.1">
                  <!-- <i class="icon icon-1"></i> -->
                  <span slot="title">各省交易额排名</span>
                </el-menu-item>

                <el-menu-item index="/tech0.2">
                  <!-- <i class="icon icon-2"></i> -->
                  <span slot="title">湖北省内各市排名</span>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="2">
                <template slot="title">
                  <i class="icon icon-ios"></i>
                  <span>技术交易规模</span>
                </template>

                <el-menu-item index="/tech1.1">
                  <i class="icon icon-1"></i>
                  <span slot="title">成交金额分析</span>
                </el-menu-item>

                <el-menu-item index="/tech1.2">
                  <i class="icon icon-2"></i>
                  <span slot="title">合同数量分析</span>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="3">
                <template slot="title">
                  <i class="icon icon-danwei"></i>
                  <span>技术合同类别分析</span>
                </template>

                <el-menu-item index="/tech2.1">
                  <i class="icon icon-3"></i>
                  <span slot="title">各类别成交金额占比</span>
                </el-menu-item>

                <el-menu-item index="/tech2.2">
                  <i class="icon icon-4"></i>
                  <span slot="title">各类别成交金额</span>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="4">
                <template slot="title">
                  <i class="icon icon-guanli"></i>
                  <span>知识产权构成</span>
                </template>

                <el-menu-item index="/tech3.1">
                  <i class="icon icon-5"></i>
                  <span slot="title">知识产权类别构成</span>
                </el-menu-item>

                <el-menu-item index="/tech3.2">
                  <i class="icon icon-6"></i>
                  <span slot="title">专利类别构成</span>
                </el-menu-item>

                <el-menu-item index="/tech3.3">
                  <i class="icon icon-7"></i>
                  <span slot="title" :title="value[0]">（涉知）类型构成</span>
                </el-menu-item>

                <el-menu-item index="/tech3.4">
                  <i class="icon icon-8"></i>
                  <span slot="title" :title="value[1]">（涉知）领域成交额</span>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="5">
                <template slot="title">
                  <i class="icon icon-android"></i>
                  <span>技术要素领域分析</span>
                </template>

                <el-menu-item index="/tech4.1">
                  <i class="icon icon-9"></i>
                  <span slot="title">各领域成交额</span>
                </el-menu-item>

                <el-menu-item index="/tech4.2">
                  <i class="icon icon-xinwen"></i>
                  <span slot="title">各技术领域成交额占比</span>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="6">
                <template slot="title">
                  <i class="icon icon-modification"></i>
                  <span>科技计划项目构成</span>
                </template>

                <el-menu-item index="/tech5.1">
                  <i class="icon icon-rili"></i>
                  <span slot="title">科技计划项目构成</span>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="7">
                <template slot="title">
                  <i class="icon icon-mine"></i>
                  <span>技术交易主体构成</span>
                </template>

                <el-menu-item index="/tech6.1">
                  <i class="icon icon-kecheng"></i>
                  <span slot="title">技术交易主体构成</span>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="8">
                <template slot="title">
                  <i class="icon icon-account-information"></i>
                  <span>技术交易区域分布</span>
                </template>

                <el-menu-item index="/tech7.1">
                  <i class="icon icon-picturecode"></i>
                  <span slot="title">买方视角的区域成交分布</span>
                </el-menu-item>

                <el-menu-item index="/tech7.2">
                  <i class="icon icon-connection-bars"></i>
                  <span slot="title">卖方视角的区域成交分布</span>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="9">
                <template slot="title">
                  <i class="icon icon-project-query"></i>
                  <span>技术交易流向分析</span>
                </template>

                <el-menu-item index="/tech8.1">
                  <i class="icon icon-lab"></i>
                  <span slot="title">湖北省-其他省</span>
                </el-menu-item>

                <el-menu-item index="/tech8.2">
                  <i class="icon icon-company"></i>
                  <span slot="title">湖北省-国外</span>
                </el-menu-item>

                <el-menu-item index="/tech8.3">
                  <i class="icon icon-1"></i>
                  <span slot="title">湖北省内各市</span>
                </el-menu-item>
              </el-submenu>

              <el-submenu index="10">
                <template slot="title">
                  <i class="icon icon-research-overview"></i>
                  <span>高等院校突出领域</span>
                </template>

                <el-menu-item index="/tech9.1">
                  <i class="icon icon-warning"></i>
                  <span slot="title">领域成交额情况</span>
                </el-menu-item>

                <el-menu-item index="/tech9.2">
                  <i class="icon icon-add"></i>
                  <span slot="title">成交额占比情况</span>
                </el-menu-item>
              </el-submenu>

            </el-menu>
          </div>
        </Menubar>
      </div>
      <div class="tech__layout__content">
        <slot></slot>
      </div>
      <div class="tech__layout__right">
        <Menubar :style="rightStyle">
          <div slot="menu-title" class="menu-box-title">
            <span>省市地区</span>
          </div>
          <div slot="menu-list" class="menu-box-list">
            <div class="btn-list">
              <el-menu :default-active="currentIndex" background-color="#001529" text-color="#ffffff" active-text-color="#ffd04b" style="max-height:500px" @select="handleSelect">

                <el-menu-item :index="item.btnTxt"  v-for="item in btnArr" :key="item.btnTxt">
                  <span slot="title">{{item.btnTxt}}</span>
                </el-menu-item>
              </el-menu>
            <!-- <div class="menu-item" v-for="item in btnArr" :key="item.btnTxt">
              <Techbtn :value="item.btnTxt" :txtList="item.btnList"></Techbtn>
            </div> -->
            </div>
          </div>
        </Menubar>
      </div>
    </div>

  </section>
</template>

<script>
import Topbar from './topbar.vue'
import Menubar from './menubar.vue'
import Techbtn from './tech-btn.vue'

export default {
  data () {
    return {
      currentLeft: '30px',
      leftStyle: 'left:30px;display:inline',
      rightStyle: 'right:30px;display:inline',
      btnArr: [
        {btnTxt: '湖北省'},
        // {btnTxt: '省直辖县级行政区划'},
        {btnTxt: '武汉市'},
        {btnTxt: '仙桃市'},
        {btnTxt: '十堰市'},
        {btnTxt: '咸宁市'},
        {btnTxt: '天门市'},
        {btnTxt: '孝感市'},
        {btnTxt: '宜昌市'},
        {btnTxt: '恩施土家族苗族自治州'},
        {btnTxt: '潜江市'},
        {btnTxt: '神农架林区'},
        {btnTxt: '荆州市'},
        {btnTxt: '荆门市'},
        {btnTxt: '襄阳市'},
        {btnTxt: '鄂州市'},
        {btnTxt: '随州市'},
        {btnTxt: '黄冈市'},
        {btnTxt: '黄石市'}
      ],
      value: ['（涉知）技术合同类型构成', '（涉知）技术合同领域成交额']
    }
  },
  components: {
    Topbar,
    Menubar,
    Techbtn
  },
  computed: {
    active () {
      return this.$route.path
    },
    menu_title () {
      var currentStatus = this.refreshMenu()
      return currentStatus
    },
    currentIndex () {
      return this.$store.state.currentCity
    }
  },
  methods: {
    refreshMenu () {
      if (this.$store.state.menu_status === '隐藏菜单') {
        this.currentLeft = '-400px'
        this.rightStyle = 'right:30px;display:none'
        this.leftStyle = 'left:30px;display:none'
        return '数据统计 '
      } else {
        this.currentLeft = '30px' // '30px'
        this.rightStyle = 'right:30px;display:inline'
        this.leftStyle = 'left:30px;display:inline'
        return '数据统计'
      }
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
      this.$store.commit('GET_CURRENT_CITY', key)
    }
  }
}
</script>

<style lang="scss">
.tech__layout {
  margin: 0 auto;
  padding-top: 0;
  // min-width: 1200px - $sidebar-width;
  width: 100%;
  // max-width: 1200px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex: auto;

  .tech_layout_row {
    margin-top: 50px;
    // overflow: auto;
    white-space: nowrap;
    overflow: hidden;
  }

  &__left {
    display: inline-block;
    width: 20%;
  }

  &__right {
    display: inline-block;
    width: 20%;
    .el-menu-item {
        border-bottom: 1px solid rgba(0, 224, 255, 0.45);
    }
  }
  &__content {
    display: inline-block;
    // padding: 50px 50px 50px 50px;
    // margin-top: 50px;
    // margin-left: 20px;
    // margin-left:280px;
    // text-align: center;
    width: 60%;
    max-width: 1200px;
    min-width: 620px;
    height: 100%;
    flex: auto;
  }

  // &__footer {
  //   height: 50px;
  //   line-height: 50px;
  //   color: rgba(0,0,0,.45);
  //   font-size: 14px;
  //   text-align: center;
  //   flex: 0 0 auto;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/tech/tech-layout.vue